import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Card } from 'antd';
import password1 from 'assets/images/password1.png';

const ResetPasswordResult = () => {
    const { t } = useTranslation();

    return (
        <div className="form-signin mt-121">
            <Card className="card-password card-border">
                <div className="change-password mb-48">
                    <img className="password-img" src={password1} alt="" />
                    <h3>{t('change_password_text')}!</h3>
                </div>
                <Link to="/signin">
                    <Button className="authentication-btn" type="primary">
                        {t('login')}
                    </Button>
                </Link>
            </Card>
        </div>
    );
};

export default ResetPasswordResult;
